<template>
  <Modal modalId="downgrade-subscription-modal" size="modal-lg">
    <ModalHeader :title="$t('xDowngradeYourPlan')" icon="far fa-circle-dollar colorOrange mr-1" />
    <ModalBody>
      <div v-if="currentSubscription && newSubscription" class="container" data-test-hook="downgrade-plan-modal-body">
        <b-row class="mb-3 text-center" no-gutters>
          <p class="downgrade-desc">
            {{ $t('xDowngradingAffectDate', { 0: $moment(currentSubscription.renewalDate).format($t('xShortDate')) }) }}
          </p>
        </b-row>
        <b-row no-gutters>
          <b-col cols="6">
            <DowngradeSubscriptionCard
              :subscription-product="currentSubscription"
              :apparatuses-to-downgrade="currentApparatuses"
              :is-new-plan="false"
            />
          </b-col>
          <b-col cols="6">
            <DowngradeSubscriptionCard
              :subscription-product="newSubscription"
              :apparatuses-to-downgrade="currentApparatuses"
              :is-new-plan="true"
            />
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col class="text-center">
            <p class="text-small legal-text">*{{ $t('xPushNotificationsAreAvailableWithInstallation') }}</p>
          </b-col>
        </b-row>
        <b-row no-gutters class="mt-3">
          <b-col cols="12">
            <b-button
              variant="warning"
              class="w-100"
              @click="$emit('openPayment')"
              data-test-hook="downgrade-modal-button-continue"
            >
              {{ $t('xDowngradeNow') }}
            </b-button>
          </b-col>
        </b-row>
      </div>
    </ModalBody>
  </Modal>
</template>

<script>
import DowngradeSubscriptionCard from './DowngradeSubscriptionCard.vue'

export default {
  props: ['currentSubscription', 'newSubscription'],
  emits: ['openPayment'],
  components: {
    DowngradeSubscriptionCard
  },
  data() {
    return {
      currentApparatuses: []
    }
  },
  mounted() {
    if (this.currentSubscription?.apparatuses) {
      this.currentApparatuses = this.currentSubscription.apparatuses
    }
  }
}
</script>
<style lang="scss">
.downgrade-desc {
  line-height: 1.4rem;
  margin-bottom: 0;
  font-size: 0.875rem;
}

.legal-text {
  font-size: 0.875em;
  color: var(--gray-600);
}
</style>
